import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-datos-cobro',
    templateUrl: './datos-cobro.component.html',
    styleUrls: ['./datos-cobro.component.scss'],
    standalone: false
})
export class DatosCobroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
